"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.findAll = exports.MatchRegex = void 0;
exports.MatchRegex = {
    ulid: /^[0-9A-Z]{26}$/i,
    email: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    name: /^(?! )[a-z0-9&*,{}[\]=\-().+;'/ ]+(?<! )$/i,
    address: /[a-z0-9 ,.-]+$/,
    zip: /^\d{5}(?:[-\s]\d{4})?$/,
    phone: /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s./0-9]*$/,
    ssm: /^\$\{ssm:([^}]+)\}$/,
    year: /^\d{4}$/,
};
function findAll(text, pattern, group = 0) {
    const results = [];
    if (!pattern.global) {
        // otherwise it runs forever
        throw new TypeError('pattern must have g flag enabled');
    }
    while (true) {
        const match = pattern.exec(text);
        if (!match) {
            break;
        }
        results.push(match[group]);
    }
    return results;
}
exports.findAll = findAll;
